export default __webpack_public_path__ + "static/media/save.a0675d51.svg";